import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Upload from "../page/Upload";

const routes: AppRouteType[] = [
  {
    path: slugs.upload,
    component: Upload,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
